module.exports = __webpack_public_path__ + "media/Goals/TakingBigSteps-c2ed5d2b.svg";